import { render, staticRenderFns } from "./ChangeStateroomPopup.vue?vue&type=template&id=58f547b2&scoped=true"
import script from "./ChangeStateroomPopup.vue?vue&type=script&lang=js"
export * from "./ChangeStateroomPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangeStateroomPopup.vue?vue&type=style&index=0&id=58f547b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f547b2",
  null
  
)

export default component.exports